import request from '@/utils/request';
const path = 'tool/district/jrtt';

/** 获取行政区域列表接口 */
export function getDistrictApi(params) {
  return request({
    url: `/${path}`,
    method: 'get',
    params,
  });
}
